       <div class="content-side">
            <div class="row">
                <div class="col-2-of-2">
                    <app-column-header [headerData]="headerData"
                        (topbtnaction)="openModal(0,$event)"></app-column-header>

                    <div class="commonBlock">
                        <ag-grid-angular [pagination]="true" #agGrid [gridOptions]="gridOptions"
                            (gridReady)="onGridReady($event)" [paginationAutoPageSize]="true"
                            style="width: 100%; height: 450px;" class="ag-theme-balham">
                        </ag-grid-angular>
                    </div>
                </div>
            </div>
        </div>